module.exports = __webpack_public_path__ + "static/media/9.f490f973.gif";